import { _THEME } from "../../theme";

const mainColor = _THEME.color.primary.main;
const errorColor = _THEME.color.error;
const mainColor2 = _THEME.color.primary.accent1;
const accentColor = _THEME.color.accent.main;
const greenColor = _THEME.color.green;
const sm1 = _THEME.size.sm[1];
const sm2 = _THEME.size.sm[2];
const sm3 = _THEME.size.sm[3];
const md1 = _THEME.size.md[1];
const md2 = _THEME.size.md[2];
const md3 = _THEME.size.md[3];
const lg1 = _THEME.size.lg[1];
const lg2 = _THEME.size.lg[2];
const lg3 = _THEME.size.lg[3];
const shadow8 = _THEME.shadow[8];
const shadow9 = _THEME.shadow[9];
const grey1 = _THEME.color.grey.accent1;
const grey2 = _THEME.color.grey.accent2;
const grey4 = _THEME.color.grey.accent4;
const grey5 = _THEME.color.grey.accent5;

const mobileQuery = "@media only screen and (max-width: 600px)";
const tabQuery = "@media only screen and (max-width: 992px)";
const deskQuery = "@media only screen and (min-width: 993px)";

export const _STYLES = {
  mainColor: _THEME.color.primary.main,
  carousel: {
    height: "160px",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
  },
  container: {
    maxWidth: "100%",
    margin: "0 auto",
    padding: "0 1rem",
    "@media (min-width: 476px)": {
      width: "100%",
    },
    " @media (min-width: 768px)": {
      width: 750,
    },
    "@media (min-width: 992px)": {
      width: 970,
    },
    "@media (min-width: 1200px)": {
      width: "95%",
      maxWidth: 1400,
    },
  },
  navBarWrap: {
    background: "#fff",
    padding: "0 1rem",
    zIndex: 100,
    height: 82,
    [tabQuery]: {
      height: 60,
    },
    transition: "0.2s all ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  navBarShadow: {
    boxShadow: shadow9,
  },
  navBarHeader: {
    marginBottom: "0 !important",
    color: accentColor,
    fontSize: md2,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
    fontWeight: "600 !important",
  },
  footerHeader: {
    marginBottom: "0 !important",
    color: "#fff",
    fontSize: md1,
  },
  navLink: {
    color: accentColor,
    fontSize: md1,
    fontWeight: 500,
    [deskQuery]: {
      "&:hover": {
        color: mainColor,
      },
    },
    [tabQuery]: {
      fontSize: sm3,
      padding: "4px 0",
      display: "block",
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
  },
  customFont: {
    fontFamily: "Share Tech Mono, sans-serif !important",
    textTransform: "uppercase",
    letterSpacing: 4,
    fontWeight: 600,
  },
  mainHeader: {
    fontSize: lg2,
    lineHeight: 1.3,
    [tabQuery]: {
      fontSize: md3,
    },
    [mobileQuery]: {
      fontSize: md2,
    },
  },
  sectionHeader: {
    fontSize: lg1,
    [tabQuery]: {
      fontSize: md2,
    },
    [mobileQuery]: {
      fontSize: md1,
    },
    lineHeight: 1.3,
  },
  miniHeader: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    lineHeight: 1.3,
  },
  normalHeader: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    lineHeight: 1.3,
    fontWeight: 400,
  },
  filterHeader: {
    fontSize: sm3,
    [tabQuery]: {
      fontSize: sm2,
    },
    [mobileQuery]: {
      fontSize: sm1,
    },
    fontWeight: 400,
  },
  subHeader: {
    fontSize: md3,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
  },
  colorPrimary: {
    color: mainColor,
  },
  colorError: {
    color: errorColor,
  },
  colorText: {
    color: grey4,
  },
  colorSubText: {
    color: grey5,
  },
  padTopXl: {
    paddingTop: 120,
    [tabQuery]: {
      paddingTop: 60,
    },
  },
  padTopLg: {
    paddingTop: 90,
    [tabQuery]: {
      paddingTop: 40,
    },
  },
  padTopMd: {
    paddingTop: 60,
    [tabQuery]: {
      paddingTop: 40,
    },
  },
  padTopSm: {
    paddingTop: 40,
    [tabQuery]: {
      paddingTop: 20,
    },
  },
  padBottomXl: {
    paddingBottom: 120,
    [tabQuery]: {
      paddingBottom: 60,
    },
  },
  padBottomLg: {
    paddingBottom: 90,
    [tabQuery]: {
      paddingBottom: 40,
    },
  },
  padBottomMd: {
    paddingBottom: 60,
    [tabQuery]: {
      paddingBottom: 40,
    },
  },
  padBottomSm: {
    paddingBottom: 40,
    [tabQuery]: {
      paddingBottom: 20,
    },
  },
  imgPlaceholder: {
    width: "100%",
    height: "100%",
    backgroundColor: grey1,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    "&::after": {
      content: '""',
      display: "block",
      width: "100%",
      height: "100%",
      backgroundImage: `url(
        'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="darkgrey" viewBox="0 0 24 24"><path d="M14 9l-2.519 4-2.481-1.96-5 6.96h16l-6-9zm8-5v16h-20v-16h20zm2-2h-24v20h24v-20zm-20 6c0-1.104.896-2 2-2s2 .896 2 2c0 1.105-.896 2-2 2s-2-.895-2-2z"/></svg>'
      )`,
      color: "blue",
      backgroundRepeat: " no-repeat",
      backgroundPosition: "center center",
    },
  },
  imgWrap: {
    height: "100%",
  },
  imgInnerWrap: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    position: "relative",
    zIndex: 5,
    "& > img": {
      width: "auto !important",
      height: "100% !important",
      objectFit: "contain",
    },
    textAlign: "center",
  },
  imgContainer: {
    height: 250,
    position: "relative",
    [tabQuery]: {
      height: 150,
    },
  },
  bgImgPlaceholder: {
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    overflow: "hidden",
    "& div": {
      top: "0",
      left: "0",
      right: "0",
      width: "100%",
      bottom: "0",
      height: "100%",
      zIndex: 1,
      position: "absolute",
      background: "rgb(93 93 93 / 20%)",
      backdropFilter: "blur(8px)",
    },
    "& img": {
      objectFit: "cover",
      width: "100%",
      height: "100%",
    },
  },

  paraLine: {
    lineHeight: 1.75,
  },
  headerLine: {
    lineHeight: 1.5,
  },
  textSm1: {
    fontSize: sm1,
  },
  textSm2: {
    fontSize: sm2,
    [tabQuery]: {
      fontSize: sm1,
    },
  },
  textSm3: {
    fontSize: sm3,
    [tabQuery]: {
      fontSize: sm2,
    },
    [mobileQuery]: {
      fontSize: sm1,
    },
  },
  textMd1: {
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },

    [mobileQuery]: {
      fontSize: sm2,
    },
  },
  textMd2: {
    fontSize: md2,
    [tabQuery]: {
      fontSize: md1,
    },
    [mobileQuery]: {
      fontSize: sm3,
    },
  },
  textMd3: {
    fontSize: md3,
    [tabQuery]: {
      fontSize: md2,
    },
    [mobileQuery]: {
      fontSize: md1,
    },
  },
  textLg1: {
    fontSize: lg1,
    [tabQuery]: {
      fontSize: md3,
    },
    [mobileQuery]: {
      fontSize: md2,
    },
  },
  textLg2: {
    fontSize: lg2,
    [tabQuery]: {
      fontSize: lg1,
    },
    [mobileQuery]: {
      fontSize: md3,
    },
  },
  textLg3: {
    fontSize: lg3,
    [tabQuery]: {
      fontSize: lg2,
    },
    [mobileQuery]: {
      fontSize: lg1,
    },
  },
  fontLight: {
    fontWeight: 300,
  },
  fontRegular: {
    fontWeight: 400,
  },
  fontMid: {
    fontWeight: 500,
  },
  pb0: {
    paddingBottom: "0 !important",
  },
  fontBold: {
    fontWeight: 600,
  },
  mt1: {
    marginTop: "1rem",
  },
  mt2: {
    marginTop: "2rem",
  },
  mb1: {
    marginBottom: "1rem",
  },
  mb2: {
    marginBottom: "2rem",
  },
  mb4: {
    marginBottom: "4rem",
  },
  logo: {
    height: 50,
    [tabQuery]: {
      height: 40,
    },
  },
  bgGrey: {
    background: grey1,
  },
  bgBlue: {
    background: mainColor2,
  },
  bgFeature: {
    backgroundColor: mainColor2,
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23F0F8FF'/%3E%3Cstop offset='1' stop-color='%2375C6FE'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23b3dfff'/%3E%3Cstop offset='1' stop-color='%2375C6FE'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg transform='translate(1000 0)'%3E%3Cg %3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform='rotate(-151.2 0 0)'%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.5' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    backgroundAttachment: "fixed",
    backgroundSize: "cover",
  },
  aboutImg: {
    maxHeight: 500,
    [tabQuery]: {
      height: 250,
    },
    display: "flex",
    margin: "auto",
  },
  dirColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },
  formWrap: {
    padding: "2rem",
    background: "#fff",
    maxWidth: "calc(600px + 4rem)",
    margin: "auto",
    boxShadow: shadow9,
  },
  contactWrap: {
    padding: "2rem",
    [tabQuery]: {
      padding: "0 1rem",
    },
    background: "#fff",
    maxWidth: "calc(600px + 4rem)",
    margin: "auto",
  },
  bodyWrap: {
    minHeight: "100vh",
    maxHeight: "100vh",
    overflowY: "auto",
    height: 1,
  },
  // bodyWrap: {
  //   minHeight: "calc(100vh - 82px)",
  //   maxHeight: "calc(100vh - 82px)",
  //   [tabQuery]: {
  //     minHeight: "calc(100vh - 60px)",
  //     maxHeight: "calc(100vh - 60px)",
  //   },
  //   [mobileQuery]: {
  //     minHeight: "calc(100vh - 60px)",
  //     maxHeight: "calc(100vh - 60px)",
  //   },
  //   overflowY: "auto",
  //   height: 1,
  // },
  bodyInnerWrap: {
    minHeight: "calc(100vh - 82px)",
  },
  h100: {
    height: "100%",
  },
  textCenter: {
    textAlign: "center",
  },
  textJustify: {
    textAlign: "justify",
  },
  surveyImg: {
    display: "flex",
    margin: "2rem auto",
  },
  textLeft: {
    textAlign: "left",
  },
  textRight: {
    textAlign: "right",
  },
  footerWrap: {
    color: "#fff",
    background: accentColor,
  },
  footerBg: {
    position: "absolute",
    bottom: 0,
    fill: mainColor,
    zIndex: -1,
  },
  footerLink: {
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
    fontSize: md1,
    color: "#fff",
    "&:hover": {
      color: mainColor,
    },
  },
  socialWrap: {
    "& svg": {
      width: 40,
      height: 40,
      fill: "#fff",
      transition: "0.6s all ease",
      "&:hover": {
        fill: accentColor,
      },
    },
  },
  colorLight: {
    color: "#fff",
  },
  notFoundWrap: {
    minHeight: "calc(100vh - 284px)",
  },
  shadowBlock: {
    padding: "2rem",
    boxShadow: shadow8,
  },
  block: {
    padding: "4rem 2.5rem",
    background: "#fff",
  },
  w100: {
    width: "100%",
  },
  blockBordered: {
    border: "16px solid rgb(0 103 108 / 20%)",
  },
  bgAccent: {
    background: accentColor,
  },
  bgPrimary: {
    background: mainColor,
  },
  mxAuto: {
    marginLeft: "auto",
    marginRight: "auto",
  },

  imgSuccess: {
    height: 250,
  },
  world: {
    position: "absolute",
    bottom: -16,
    right: 0,
    [tabQuery]: {
      opacity: 0.2,
    },
  },
  overflowHidden: {
    overflow: "hidden",
  },

  justifyCenter: {
    justifyContent: "center",
  },
  floatBtn: {
    width: "auto",
    "& > div > div": {
      flexDirection: "row !important",
      padding: "12px 16px !important",
    },
    "& > div > div > div:first-child": {
      marginRight: "8px !important",
    },
  },
  imgCover: {
    padding: "0 !important",
    height: 300,
    background: grey1,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "contain",
    },
  },
  qrBtn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "auto !important",

    padding: " 1rem 2rem !important",
    "& svg": {
      width: "5em",
      height: "5em",
      marginBottom: "1rem",
    },
  },
  hMaxContent: {
    height: "max-content",
  },
  carouselCover: {},
  carouselItem: {
    height: 400,
    textAlign: "center",
    background: grey1,
    display: "flex !important",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      maxHeight: "100%",
      maxWidth: "100%",
      objectFit: "contain",
    },
  },
  itemFoundIcon: {
    fontSize: 36,

    color: greenColor,
  },
  timeline: {
    margin: "auto",
    width: "75%",
  },
  coloredDivider: {
    background: grey4,
  },
  pRelative: {
    position: "relative",
  },
  catHomeBg: {
    top: "0",
    left: "50%",
    transform: "translate(-50%, 0)",
    width: 450,
    height: 450,
    [tabQuery]: {
      width: 200,
      height: 200,
    },
    zIndex: -1,
    position: "absolute",
    background: mainColor,
    borderRadius: "50%",
  },
  catPostBg: {
    top: "0",
    left: "50%",
    transform: "translate(-50%, 0)",
    width: 450,
    height: 450,
    [tabQuery]: {
      width: 200,
      height: 200,
    },
    zIndex: -1,
    position: "absolute",
    background: mainColor,
    borderRadius: 32,
  },
  catHomeBg2: {
    top: "0",
    left: "50%",
    transform: "translate(-50%, 0)",
    width: 450,
    height: 450,
    zIndex: -1,
    position: "absolute",
    background: mainColor2,
    borderRadius: "50%",
    [tabQuery]: {
      width: 200,
      height: 200,
    },
  },
  catHomeImg: {
    maxHeight: 550,
    [tabQuery]: {
      maxHeight: 250,
    },
  },
  borderless: {
    border: 0,
  },
  featureText: {
    minHeight: 115,
    [mobileQuery]: {
      minHeight: 75,
    },
  },
  headSection: {
    padding: 32,
    borderLeft: `16px solid ${mainColor}`,
    [tabQuery]: {
      padding: 16,
      borderLeft: `8px solid ${mainColor}`,
    },
  },
  downloadBlock: {
    display: "block",
    transition: "0.6s all ease",
    transform: "translateY(0)",
    "&:hover": {
      transform: "translateY(-5px)",
    },
  },
  downloadBlockImg: {
    maxHeight: 50,
  },
  stripLeft: {
    paddingLeft: 32,
    borderLeft: `16px solid ${mainColor}`,
    [tabQuery]: {
      paddingLeft: 16,
      borderLeft: `8px solid ${mainColor}`,
    },
  },
  didYouKnow: {
    backgroundColor: "#144263",
  },
  didYouKnowInner: {
    maxWidth: 768,
  },
  blogImg: {
    height: 250,
    [tabQuery]: {
      height: 150,
    },
    "& img": {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },
  },
  blogImgBg: {
    background: mainColor2,
    position: "absolute",
    left: 0,
    top: 0,
    width: 300,
    borderRadius: 16,
    height: "100%",
    zIndex: -1,
  },
  imgBorder: {
    border: `1px solid ${grey2}`,
  },
  listItem: {
    display: "flex !important",
    padding: "8px 0 !important",
    gap: "8px",
    justifyContent: "flex-start !important",
    alignItems: "flex-start !important",
  },
  noUserSelection: {
    userSelect: "none",
  },
  blogDetailImage: {
    height: 400,
    [tabQuery]: {
      maxHeight: 250,
    },
  },
  blogInner: {
    lineHeight: 1.75,
    "& img": {
      maxWidth: "100%",
      margin: "2rem auto",
    },
    fontSize: md1,
    [tabQuery]: {
      fontSize: sm3,
    },
    [mobileQuery]: {
      fontSize: sm2,
    },
  },
  contactImg: {
    [tabQuery]: {
      height: 200,
    },
  },
  mobHeaderImg: {
    [tabQuery]: {
      height: 250,
      margin: "auto",
      display: "flex",
    },
  },
  blogCard: {
    "& .ant-card-body": {
      [tabQuery]: {
        padding: "12px 8px",
      },
    },
  },
  navDropdown: {
    "& .ant-dropdown-menu": {
      padding: 8,
    },
  },
  navBtn: {
    width: 40,
    height: 40,
    padding: 0,
  },
  downloadBlockImgHome: {
    maxHeight: 70,
    [tabQuery]: {
      maxHeight: 50,
    },
  },
  px1: {
    paddingLeft: "1rem",
    paddingRight: "1rem",
  },
  mobCatBg: {
    [mobileQuery]: {
      position: "absolute",
      right: "0",
      opacity: 0.2,
      zIndex: -1,
    },
  },
  textWrap: {
    textWrap: "wrap",
  },
  flexColumn: {
    flexDirection: "column",
    display: "flex",
    [mobileQuery]: {
      gap: 8,
    },
  },
  statWrap: {
    "& .ant-statistic-title": {
      fontSize: sm3,
      [mobileQuery]: {
        fontSize: sm2,
      },
    },
    "& .ant-statistic-content": {
      fontSize: md1,
      [mobileQuery]: {
        fontSize: sm3,
      },
    },
  },
  postTop: {
    background: mainColor2,
    padding: " 12px 16px",
    borderRadius: 8,
  },
  mainLoader: {
    minHeight: "calc(100vh - 470px)",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  postFilters: {
    "& .ant-collapse-header": {
      alignItems: "center !important",
    },
  },
  mobCardBody: {
    display: "flex",
    alignItems: "center",
  },
  notFoundImg: {
    [tabQuery]: {
      maxHeight: 500,
      display: "block",
      margin: "auto",
    },
  },
  clinicRegFg: {},
  clinicRegBg: {
    position: "absolute",
    zIndex: -1,
    left: "0",
    bottom: "-4px",
  },
  clinicWrap: {
    backdropFilter: "blur(32px)",
    borderRadius: "12px",
    margin: "auto",
    padding: "2rem",
    // maxWidth: "calc(600px + 4rem)",
    background: "rgb(117 198 254 / 10%)",
    border: "1px solid #0505050f",
  },
};
